import React from "react";
import Modal from "../../components/Modal";
import i18n from "../../i18n";
import FileChooseButton from "../../components/FileChooseButton";
import TouchEffect from "../../components/TouchEffect/TouchEffect";

export default class AgeLimitModal extends Modal {

  componentDidMount() {
    // window.webviewEventsListeners.backPress.push(() => {
    //   this.dismiss();
    //   return true;
    // });
  }

  dismiss(trigger) {
    // window.webviewEventsListeners.backPress.pop();
    super.dismiss(trigger);
  }

  handleFileChooseButtonClick = () => {
    this.props.onFileChooseButtonClick && this.props.onFileChooseButtonClick();
  }

  handleFilesSelected = (files) => {
    this.props.onFilesSelected && this.props.onFilesSelected(files);
    this.dismiss();
  };

  handleContinueButtonClick = () => {
    this.props.onContinue && this.props.onContinue();
    this.dismiss();
  };

  renderModal() {
    const ageLess13 = this.props.ageVerdict === "restriction_13";
    const personCount = this.props.peopleAmountOnPhoto;

    let title = "";
    let text;
    if (ageLess13) {
      text = "age_limit_modal__13_text";
    } else {
      title = "age_limit_modal__18_title";
      text = personCount > 1 ? "age_limit_modal__18_several_persons_text" : "age_limit_modal__18_one_person_text";
    }

    return <React.Fragment>
      {title && <h2 dangerouslySetInnerHTML={{__html: i18n.t(title)}} />}
      {text && <p dangerouslySetInnerHTML={{__html: i18n.t(text)}} />}

      <div className="portrait-image-container">
        <img src={this.props.photoUrl} alt="" />
        <SvgEighteenPlusIcon />
      </div>

      {!ageLess13 && <button className="btn-upload-foto" onClick={this.handleContinueButtonClick}>
        {i18n.t("age_limit_modal__confirm")}
        <TouchEffect />
      </button>}

      <FileChooseButton
        className={ageLess13 ? "btn-full btn" : "btn"}
        onClick={this.handleFileChooseButtonClick}
        onFilesSelected={this.handleFilesSelected}>
        {i18n.t("age_limit_modal__choose_photo")}
        <TouchEffect />
      </FileChooseButton>

    </React.Fragment>;
  }
}

function SvgEighteenPlusIcon() {
  return <svg viewBox="0 0 103 102">
    <defs>
      <clipPath id="iyebmdmp2a">
        <path d="M1242 0v2208H0V0h1242z"/>
      </clipPath>
      <clipPath id="21tjoaw2jb">
        <path d="M48 0a47.789 47.789 0 0 1 29 9.747A48.236 48.236 0 0 1 89.785 24.36l1.351 44.72A48.198 48.198 0 0 1 77.15 86.137 47.79 47.79 0 0 1 48 96C21.49 96 0 74.51 0 48S21.49 0 48 0z"/>
      </clipPath>
      <clipPath id="u39mikj0tc">
        <path d="M11.745 0v26.904H6.327V8.35H0v-3.6c1.67-.074 2.839-.186 3.507-.334 1.064-.235 1.93-.705 2.597-1.41.458-.483.805-1.126 1.04-1.93C7.28.594 7.348.235 7.348 0h4.397z"/>
      </clipPath>
      <clipPath id="p800bx72td">
        <path d="M9.37 0c2.684 0 4.762.69 6.234 2.069 1.472 1.38 2.209 3.046 2.209 5 0 .879-.195 1.822-.585 2.83-.39 1.008-1.234 1.883-2.533 2.625 1.324.743 2.32 1.726 2.988 2.95.668 1.225 1.002 2.592 1.002 4.101 0 2.264-.838 4.19-2.515 5.78-1.676 1.59-4.017 2.384-7.023 2.384-3.005 0-5.281-.798-6.828-2.393C.773 23.762 0 21.839 0 19.576c0-1.51.343-2.877 1.03-4.101.686-1.225 1.691-2.147 3.015-2.765-1.299-.866-2.143-1.803-2.533-2.811-.39-1.008-.584-1.951-.584-2.83 0-1.954.736-3.62 2.208-5C4.608.689 6.686 0 9.37 0zm0 15.03c-1.187 0-2.13.355-2.83 1.066-.698.711-1.048 1.754-1.048 3.127 0 1.323.343 2.35 1.03 3.08.686.73 1.636 1.094 2.848 1.094s2.162-.364 2.848-1.094c.687-.73 1.03-1.757 1.03-3.08 0-1.373-.35-2.416-1.048-3.127-.7-.711-1.642-1.067-2.83-1.067zm0-10.762c-1.064 0-1.896.3-2.495.9-.6.6-.9 1.431-.9 2.495 0 .977.303 1.775.909 2.394.594.618 1.422.927 2.486.927 1.076 0 1.908-.309 2.496-.927.587-.619.881-1.417.881-2.394 0-1.064-.294-1.896-.881-2.496-.588-.6-1.42-.9-2.496-.9z"/>
      </clipPath>
      <clipPath id="n4o234vk8e">
        <path d="M2.5 0A2.5 2.5 0 0 1 5 2.5v12a2.5 2.5 0 1 1-5 0v-12A2.5 2.5 0 0 1 2.5 0z"/>
      </clipPath>
    </defs>
    <g clipPath="url(#iyebmdmp2a)" transform="translate(-778 -964)">
      <g clipPath="url(#21tjoaw2jb)" transform="translate(781 967)">
        <path fill="#FFF" d="M0 0h91.136v96H0V0z"/>
      </g>
      <path d="M870.785 991.36A48.236 48.236 0 0 0 858 976.747 47.789 47.789 0 0 0 829 967c-26.51 0-48 21.49-48 48s21.49 48 48 48a47.79 47.79 0 0 0 29.15-9.862 48.198 48.198 0 0 0 13.986-17.059" stroke="#FF1743" strokeWidth="6" fill="none" strokeLinecap="round" strokeMiterlimit="10"/>
      <g clipPath="url(#u39mikj0tc)" transform="translate(807 1001.13)">
        <path fill="#FF1743" d="M0 0h11.745v26.904H0V0z"/>
      </g>
      <g clipPath="url(#p800bx72td)" transform="translate(826.501 1001)">
        <path fill="#FF1743" d="M0 0h18.685v27.74H0V0z"/>
      </g>
      <g clipPath="url(#n4o234vk8e)" transform="translate(870 1006)">
        <path fill="#FF1743" d="M0 0h5v17H0V0z"/>
      </g>
      <g>
        <g clipPath="url(#n4o234vk8e)" transform="rotate(90 -65.5 946.5)">
          <path fill="#FF1743" d="M0 0h5v17H0V0z"/>
        </g>
      </g>
    </g>
  </svg>;
}